"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
const User = __importStar(require("../../../../../../user"));
const openapi_1 = require("../../../../../openapi");
const Common = __importStar(require("../../common"));
const ExportJob = __importStar(require("../export-job"));
const Fleet = __importStar(require("../schema"));
const Alarms = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Alarms.Spec';
/*
 * `routes/v2/api/fleet/alarms/router.js`
 *
 * `filteredList` accepts either a `read` role or a fleet SAT (`?sat=`); the
 * two guards are OR'd, so both security requirements apply. Filters and
 * customer are `read` only; the export routes are `AdminUserRouteGuard`.
 */
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const FilteredListQuery = effect_1.Schema.Struct({
    start: effect_1.Schema.propertySignature(Common.TimestampFromString).annotations({
        description: 'Start timestamp for the filter range (positive integer).',
    }),
    end: effect_1.Schema.propertySignature(Common.TimestampFromString).annotations({
        description: 'End timestamp for the filter range (positive integer). Must exceed `start`.',
    }),
    page: effect_1.Schema.propertySignature(Common.PositiveIntFromString).annotations({
        description: 'Page number for pagination (positive integer).',
    }),
    size: effect_1.Schema.propertySignature(Common.PositiveIntFromString.pipe(effect_1.Schema.lessThanOrEqualTo(100))).annotations({
        description: 'Number of items per page (positive integer, maximum 100).',
    }),
    name: effect_1.Schema.optionalWith(Device.Capability.Alarm.AlarmTag, { exact: true }).annotations({
        description: 'Filter by alarm name.',
    }),
    search: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyTrimmedString, { exact: true }).annotations({
        description: 'Search by alarm name or device ID (partial match, case-insensitive).',
    }),
    model: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Common.ModelCode), {
        exact: true,
    }).annotations({ description: 'Filter by device models.' }),
    tenantIds: effect_1.Schema.optionalWith(Common.TenantIds, { exact: true }),
    vendor: effect_1.Schema.optionalWith(Device.Vendor.Code, { exact: true }).annotations({
        description: 'Filter by vendor code.',
    }),
    severity: effect_1.Schema.optionalWith(Device.Capability.Alarm.Severity, { exact: true }).annotations({
        description: 'Filter by alarm severity.',
    }),
    status: effect_1.Schema.optionalWith(Device.History.AlarmStatus, { exact: true }).annotations({
        description: 'Filter by alarm status.',
    }),
    customer: effect_1.Schema.optionalWith(User.Id, { exact: true }).annotations({
        description: 'Filter by customer ID.',
    }),
    device: effect_1.Schema.optionalWith(Device.Class.Common.Id, { exact: true }).annotations({
        description: 'Filter by device ID. Required when includeActiveOutsideRange is true, and when authenticating with a SAT.',
    }),
    includeActiveOutsideRange: effect_1.Schema.optionalWith(effect_1.Schema.BooleanFromString, { exact: true }).annotations({
        description: 'When true, start/end apply only to dismissed/resolved alarms; active alarms are included regardless of occurrence time. Requires device.',
    }),
    orderBy: effect_1.Schema.optionalWith(Alarms.OrderBy, { exact: true }).annotations({
        description: 'Field to sort the results by. Requires direction.',
    }),
    direction: effect_1.Schema.optionalWith(Common.SortDirection, { exact: true }).annotations({
        description: "Direction for sorting ('asc' or 'desc'). Requires orderBy.",
    }),
});
const FiltersQuery = effect_1.Schema.Struct({
    keys: effect_1.Schema.optionalWith(effect_1.Schema.Array(Fleet.FilterKey), { exact: true }).annotations({
        // Shape of `fleet/spec.ts`; the handler behind this route is missing, so
        // nothing reads the parameter yet (see the operation description).
        description: 'Filter facets to retrieve. Ignored for now: the route never reads it, every call ends in the v1 500 described on the operation.',
    }),
});
const CustomerQuery = effect_1.Schema.Struct({
    customerId: User.Id,
});
const filteredList = platform_1.HttpApiEndpoint.get('filteredList') `/filteredList`
    .setUrlParams(FilteredListQuery)
    .addSuccess(openapi_1.Response.Success(Alarms.AlarmPage).annotations({
    description: 'Paginated alarm history',
}))
    .addError(openapi_1.Error.NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'List Fleet Alarms')
    .annotate(platform_1.OpenApi.Description, 'Returns a paginated list of the alarm history matching the filters, scoped to the tenants visible to the caller. ' +
    'With a SAT, `device` is required and must be one of the devices the token grants; otherwise 401 `NotAuthorizedError`.')
    .pipe(Common.withReadOrSatGuard, openapi_1.Error.withLegacyV2StandardErrors);
const getFilters = platform_1.HttpApiEndpoint.get('getFleetAlarmFilters') `/filters`
    .setUrlParams(FiltersQuery)
    .addSuccess(openapi_1.Response.Success(Fleet.FleetFilterList).annotations({
    description: 'Requested filter facets',
}))
    .annotate(platform_1.OpenApi.Title, 'Fleet Alarm Filters')
    .annotate(platform_1.OpenApi.Description, 'Returns the filter facets for the fleet alarms page, as `GET /v2/fleet/filters`. ' +
    'Known runtime quirk: the alarm controller does not export this handler, so the route currently answers a v1 500 body.')
    .pipe(Common.withReadGuard, openapi_1.Error.withLegacyV2StandardErrors);
const getCustomer = platform_1.HttpApiEndpoint.get('getFleetAlarmCustomer') `/customer`
    .setUrlParams(CustomerQuery)
    .addSuccess(openapi_1.Response.Success(Fleet.CustomerResponse).annotations({
    description: 'Customer information',
}))
    .addError(openapi_1.Error.NotFound)
    .annotate(platform_1.OpenApi.Title, 'Fleet Alarm Customer')
    .annotate(platform_1.OpenApi.Description, 'Returns the id and name of a customer (device owner), as `GET /v2/fleet/customer`. ' +
    'Known runtime quirk: the alarm controller does not export this handler, so the route currently answers a v1 500 body.')
    .pipe(Common.withReadGuard, openapi_1.Error.withLegacyV2StandardErrors);
const [createExportJob, getExportJobStatus, getExportJobDownload] = ExportJob.routes('Alarms', Alarms.CreateExportJobBody, 'alarms_export.csv');
exports.Spec = platform_1.HttpApiGroup.make('v2.fleet.alarms')
    .add(filteredList)
    .add(getFilters)
    .add(getCustomer)
    .add(createExportJob)
    .add(getExportJobStatus)
    .add(getExportJobDownload)
    .prefix('/fleet/alarms')
    .annotate(platform_1.OpenApi.Title, 'Fleet Alarms')
    .annotate(platform_1.OpenApi.Description, 'Alarm history of the fleet and its CSV export jobs')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Fleet));
//# sourceMappingURL=spec.js.map